import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import HookFormCheckboxField from 'reservations/form/components/HookFormCheckboxField';

function MarketingOptIn() {
  return (
    <Box data-testid="opt-in-section">
      <Typography variant="h3">Receive rewards & offers by:</Typography>
      <Grid container>
        <Grid item>
          <HookFormCheckboxField
            name="optInMarketingSms"
            Label={<Typography>Text message</Typography>}
          />
        </Grid>
        <Grid item>
          <HookFormCheckboxField
            name="optInMarketingEmail"
            Label={<Typography>Email</Typography>}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default MarketingOptIn;
